import { Grid } from "@mui/material";
import { poisBountyAssets } from "assets/cdn";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useAppDispatch, useImagePath } from "hooks";
import { onClosePopUp } from "redux/slices";
import {
	Background,
	Body,
	Button,
	Container,
	Description,
	Header,
	Title
} from "./styles";

interface PBV3TierCompleteProps {}

export const PBV3TierComplete: React.FC<PBV3TierCompleteProps> = () => {
	const dispatch = useAppDispatch();
	const { getImage } = useImagePath("cdn");
	const scale = useCalculateScale(400, 500);

	const onClose = () => {
		dispatch(onClosePopUp());
	};

	return (
		<Container scale={scale}>
			<CloseIconButton onClose={onClose} />
			<Header>
				<Background
					src={getImage(poisBountyAssets.v3.rewardsCollected.background)}
				/>
			</Header>
			<Body>
				<Title>
					Your Club just
					<br /> hit a Tier!
				</Title>
				<Description>
					Keep contributing to unlock the next
					<br /> tier! Check your inbox in the game for
					<br /> your bonus prize!
				</Description>
				<Grid container spacing={2}>
					<Grid
						item
						xs={12}
						/* sm={isMobile ? 6 : 12} */ display="flex"
						justifyContent="center"
					>
						<Button
							themeColor="secondary"
							onClick={onClose}
							sx={{
								minWidth: { xs: "80%" /* sm: isMobile ? "100%" : "80%" */ }
							}}
						>
							Yay!
						</Button>
					</Grid>
					{/* {isMobile && (
						<Grid item xs={12} sm={6} display="flex" justifyContent="center">
							<BackToGameButton
								source="pois_bounty_dialog"
								themeColor="secondary"
								sx={{ minWidth: { xs: "80%", sm: "100%" } }}
							/>
						</Grid>
					)} */}
				</Grid>
			</Body>
		</Container>
	);
};
